<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "PackageIndex",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
